import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { RouterLink } from '@angular/router';
import { LinkAboutBgtComponent } from '../shared/link-about-bgt/link-about-bgt.component';
import { LinkDownloadBgtComponent } from '../shared/link-download-bgt/link-download-bgt.component';
import { LinkBgtWfsComponent } from '../shared/link-bgt-wfs/link-bgt-wfs.component';
import { CallToActionComponent } from '../shared/call-to-action/call-to-action.component';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    imports: [MatIcon, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, RouterLink, LinkAboutBgtComponent, LinkDownloadBgtComponent, LinkBgtWfsComponent, CallToActionComponent]
})
export class AboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
